import { render, staticRenderFns } from "./asset-linked.vue?vue&type=template&id=0870011c&scoped=true&"
import script from "./asset-linked.vue?vue&type=script&lang=js&"
export * from "./asset-linked.vue?vue&type=script&lang=js&"
import style0 from "./asset-linked.vue?vue&type=style&index=0&id=0870011c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0870011c",
  null
  
)

export default component.exports